import React from 'react';

const CardEMI: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 8C28 6.93913 27.5786 5.92172 26.8284 5.17157C26.0783 4.42143 25.0609 4 24 4H8C6.93913 4 5.92172 4.42143 5.17157 5.17157C4.42143 5.92172 4 6.93913 4 8V24C4 25.0609 4.42143 26.0783 5.17157 26.8284C5.92172 27.5786 6.93913 28 8 28H12C12 27.3086 12 26.7656 12 26H8C7.46957 26 6.96086 25.7893 6.58579 25.4142C6.21071 25.0391 6 24.5304 6 24V11.3333H26V18C26.792 18 27.3973 18 28 18V8ZM8 6H24C24.5304 6 25.0391 6.21071 25.4142 6.58579C25.7893 6.96086 26 7.46957 26 8V9.33333H6V8C6 7.46957 6.21071 6.96086 6.58579 6.58579C6.96086 6.21071 7.46957 6 8 6Z"
      fill="black"
    />
    <path
      d="M10.8452 13.4882C10.5326 13.1756 10.1087 13 9.66667 13C9.22464 13 8.80072 13.1756 8.48816 13.4882C8.17559 13.8007 8 14.2246 8 14.6667C8 15.1087 8.17559 15.5326 8.48816 15.8452C8.80072 16.1577 9.22464 16.3333 9.66667 16.3333C10.1087 16.3333 10.5326 16.1577 10.8452 15.8452C11.1577 15.5326 11.3333 15.1087 11.3333 14.6667C11.3333 14.2246 11.1577 13.8007 10.8452 13.4882Z"
      fill="black"
    />
    <path
      d="M10.8452 18.8215C10.5326 18.5089 10.1087 18.3333 9.66667 18.3333C9.22464 18.3333 8.80072 18.5089 8.48816 18.8215C8.17559 19.134 8 19.558 8 20C8 20.442 8.17559 20.8659 8.48816 21.1785C8.80072 21.4911 9.22464 21.6666 9.66667 21.6666C10.1087 21.6666 10.5326 21.4911 10.8452 21.1785C11.1577 20.8659 11.3333 20.442 11.3333 20C11.3333 19.558 11.1577 19.134 10.8452 18.8215Z"
      fill="black"
    />
    <path
      d="M16.1785 13.4882C15.866 13.1756 15.442 13 15 13C14.558 13 14.1341 13.1756 13.8215 13.4882C13.5089 13.8007 13.3333 14.2246 13.3333 14.6667C13.3333 15.1087 13.5089 15.5326 13.8215 15.8452C14.1341 16.1577 14.558 16.3333 15 16.3333C15.442 16.3333 15.866 16.1577 16.1785 15.8452C16.4911 15.5326 16.6667 15.1087 16.6667 14.6667C16.6667 14.2246 16.4911 13.8007 16.1785 13.4882Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.67 19.67C14.5654 19.67 13.67 20.5654 13.67 21.67V22.67H29.67V21.67C29.67 20.5654 28.7746 19.67 27.67 19.67H15.67ZM29.67 23.67H13.67V27.67C13.67 28.7746 14.5654 29.67 15.67 29.67H27.67C28.7746 29.67 29.67 28.7746 29.67 27.67V23.67Z"
      fill="black"
    />
  </svg>
);

export default React.memo(CardEMI);
